if (!customElements.get('announcement-slider')) {
  customElements.define(
    'announcement-slider',
    class AnnouncementSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        new window.Splide(this, {
          type: 'loop',
          height: '100%',
          width: '100%',
          perPage: 1,
          pagination: false,
          arrows: false,
          autoplay: true,
          interval: 10000,
          direction: 'ttb'
        }).mount();
      }
    }
  );
}
